"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateObject = void 0;
const validationArray_1 = require("../Validation/validationArray");
const validationCore_1 = require("../Validation/validationCore");
const validateObject = (item, validationObject) => {
    const res = {};
    Object.entries(item).forEach(([k, v]) => {
        const key = k;
        const typeofItem = typeof v;
        const validator = validationObject[key];
        const isArray = v instanceof Array;
        switch (validator?.attributeType) {
            case 'number':
                {
                    res[key] = (0, validationCore_1.validAttributeNumberValue)(v, validator.range);
                }
                break;
            case 'array':
                {
                    if (v instanceof Array) {
                        res[key] = (0, validationArray_1.validateNumberArray)(v, validator.range);
                    }
                    else {
                        console.log('unhandled case where array not provided');
                    }
                }
                break;
            case 'boolean':
                {
                    res[key] = (0, validationCore_1.validAttributeBooleanValue)(v);
                }
                break;
            case 'enumeration':
                {
                    res[key] = (0, validationCore_1.validAttributeEnumValue)(v, validator.enumeration);
                }
                break;
            case 'bitmap': {
                res[key] = (0, validationCore_1.validAttributeBitmapValue)(v, validator.bitmap);
            }
            case 'present':
                {
                    res[key] = (0, validationCore_1.validAttributePresent)(v);
                }
                break;
            default: {
                const nextValidator = validationObject[key];
                const nextItem = v;
                if (nextValidator && nextItem) {
                    // @ts-ignore
                    const nextRes = (0, exports.validateObject)(nextItem, nextValidator);
                    res[key] = nextRes;
                }
            }
        }
    });
    return res;
};
exports.validateObject = validateObject;
